import React, {useContext} from "react";
import {TemplateWithoutBody} from "../../model/Template";
import {HeaderCard} from "../Base/HeaderCard";
import {NavigationHeader} from "../Navigation/NavigationHeader";
import TemplateTable from "./TemplateTable";
import {useTranslation} from "react-i18next";
import {UserContext} from "../../App";

interface Props {
    templates: TemplateWithoutBody[];
}

export const UserTemplateOverview: React.FC<Props> = ({templates}) => {
    const {t} = useTranslation();
    const {user} = useContext(UserContext);

    const navigation = [
        {url: "", label: t('templateManager.title')}
    ];

    return (
        <>
            <NavigationHeader path={navigation}/>
            <HeaderCard
                headline={<>{t('templateManager.overviewHeader', {name: user?.firstName ?? ""})}</>}
                body={<>{t('templateManager.overviewDescription')}</>}
            />
                    <TemplateTable
                        templates={templates}
                        selectedTemplateIds={[]}
                        readonly={true}
                        columnVisibility={{
                            difficulty: true,
                            loginPage: true,
                            campaigns: true,
                            preview: true
                        }}
                        pageSize={15}
                    />
        </>
    );
}

